export interface CurrencyState {

}

export const initialState: any = []